import { ThemeKey } from "@smartsheet/design-tokens";
import React, { HTMLAttributes } from "react";
import { forwardRef } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { CheckedState } from "../../../checkbox";
import { TypeRampV2 } from "../../../typography";
import { TypeRampUrsaProps } from "../../../typography/types";
import { optionFontTheme } from "../selectV2Theme";
import { OptionBase } from "../shared/OptionBase";
import { MultiSelectCheckbox } from "./MultiSelectCheckbox";
export interface MultiSelectOptionProps extends HTMLAttributes<HTMLDivElement> {
    checkedState: CheckedState;
    height?: number;
    isDisabled?: boolean;
}

export const MultiSelectOption = forwardRef<HTMLDivElement, MultiSelectOptionProps>(
    ({ children, checkedState, ...props }, ref) => {
        const { key } = useTheme();
        const themeMode = key as ThemeKey;
        return (
            <OptionBase ref={ref} {...props}>
                <MultiSelectCheckbox checkedState={checkedState} aria-disabled={props.isDisabled} />
                <TypeRampV2
                    lineClamp={1}
                    variant={optionFontTheme.variant(themeMode) as TypeRampUrsaProps["variant"]}
                    style={{ color: "inherit" }}
                >
                    {children}
                </TypeRampV2>
            </OptionBase>
        );
    }
);

MultiSelectOption.displayName = "MultiSelectOption";
